export function getOnboardingServicesUrl() {
  return 'https://www.hubspot.com/services/onboarding/';
}